import { createFileRoute, useNavigate, useSearch } from '@tanstack/react-router'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { cn } from '@/lib/utils'
import { useBranding } from '@utils/api'
import Loading from '@components/Loading'
import BookingWizard from '@components/BookingWizard'
import { Card, CardContent } from '@/components/ui/card'

type BookingSearch = {
  serviceId?: string
}

export const Route = createFileRoute('/booking')({
  component: Booking,
  validateSearch: (search: Record<string, unknown>): BookingSearch => {
    return {
      serviceId: search.serviceId as string | undefined,
    }
  },
})

function Booking() {
  const navigate = useNavigate()
  const { serviceId } = useSearch({ from: '/booking' })
  const { branding, isLoading, isError } = useBranding()
  const { i18n } = useTranslation()
  const [isVisible, setIsVisible] = useState(false)

  useEffect(() => {
    if (branding && branding.supportedLanguages.includes(navigator.language)) {
      i18n.changeLanguage(navigator.language)
    } else if (
      branding &&
      branding.supportedLanguages.includes(navigator.language.split('-')[0])
    ) {
      i18n.changeLanguage(navigator.language.split('-')[0])
    }
  }, [i18n, branding])

  useEffect(() => {
    if (branding) {
      setIsVisible(true)
    }
  }, [branding])

  if (isLoading) return <Loading />
  if (isError) {
    navigate({ to: '/' })
    return null
  }

  return (
    <div
      className={cn(
        'min-h-[100svh] w-full flex items-center justify-center',
        'p-4 transition-opacity duration-500 ease-in-out',
        isVisible ? 'opacity-100' : 'opacity-0'
      )}
    >
      <Card className="w-full max-w-lg bg-white p-6 rounded-2xl">
        <CardContent className="p-0">
          <BookingWizard serviceId={serviceId} stickyHeader={false} />
        </CardContent>
      </Card>
    </div>
  )
}
